import React from 'react'
import PropTypes from 'prop-types'

import Field from '../../../../../../../components/Form/Field'
import FieldLabelWrapper from '../../../../../../../features/components/Form/FieldLabelWrapper'

import { BID_PRICE } from '../../../../../../Tiktok/LineItemForms/LineItemTikTokCreate/LineItemTikTokCreateForm/fields'

const BidPriceContent = ({ formik }) => {
  return (
    <FieldLabelWrapper label="Bid Price">
      <Field formik={formik} name={BID_PRICE} placeholder="Bid Price" autoComplete="off" type="number" />
    </FieldLabelWrapper>
  )
}

BidPriceContent.propTypes = {
  formik: PropTypes.object.isRequired
}

export default BidPriceContent
